import { getAnonymousLocalizedScript } from "@devowl-wp/utils";
/**
 * Use this if you do not have the Mobx store available in your JavaScript asset.
 * E. g. the `banner.js` does not rely on the mobx store and should access the
 * localized options via `window.realCookieBanner` directly.
 */ function getOptionsFromWindow() {
    return getAnonymousLocalizedScript(process.env.slug, {
        makeBase64Encoded: [
            "codeOptIn",
            "codeOptOut",
            "codeOnPageLoad",
            "contactEmail"
        ],
        lazyParse: (obj, parseLazy)=>{
            parseLazy(obj.others, "frontend", "groups");
            parseLazy(obj.others, "frontend", "tcf");
            parseLazy(obj, "others", "customizeValuesBanner");
        }
    });
}
export { getOptionsFromWindow };
